import React from 'react';
import { Checkbox } from 'antd';
import { FormattedMessage } from 'react-intl';

import './style.scss';

const STAR_PATH =
  'M7.5 0L9.48378 4.76957L14.6329 5.18237L10.7098 8.54293L11.9084 13.5676L7.5 10.875L3.09161 13.5676L4.29018 8.54293L0.367076 5.18237L5.51622 4.76957L7.5 0Z';

interface IOptions {
  value: number;
  count: number;
  disabled: boolean;
}

interface IProps {
  title: string;
  options: IOptions[];
  onChange: (checkedValues: any) => void;
  value: number[];
  disabled?: boolean;
}

const RatingStarsRow: React.FC<{ filledCount: number }> = ({ filledCount }) => (
  <span className="filter-starts__stars" aria-hidden>
    {Array.from({ length: 5 }, (_, i) => {
      const filled = i < filledCount;
      return (
        <svg
          key={i}
          className={`filter-starts__star ${filled ? 'filter-starts__star--filled' : 'filter-starts__star--empty'}`}
          width={15}
          height={15}
          viewBox="0 0 15 15"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={STAR_PATH} />
        </svg>
      );
    })}
  </span>
);

export const FilterStars: React.FC<IProps> = ({ title, options, onChange, value, disabled = false }) => (
  <div className="filter-starts">
    <p className="filter-starts__title secondary-font">
      <FormattedMessage id={title} />
    </p>

    <Checkbox.Group value={value} onChange={onChange} disabled={disabled}>
      {options.map(({ value: starValue, count, disabled: optionDisabled }) => (
        <div className="filter-starts__row" key={starValue}>
          <Checkbox value={starValue} disabled={disabled || !count || optionDisabled}>
            <span className="filter-starts__row-content">
              <RatingStarsRow filledCount={starValue} />
              {count > 0 && (
                <span className="filter-box__option-count" style={{ marginLeft: '4px' }}>
                  ({count})
                </span>
              )}
            </span>
          </Checkbox>
        </div>
      ))}
    </Checkbox.Group>
  </div>
);
